import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetStationTypes = ():{ stationTypes: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelValuePair[], AxiosError>('/DestinationBin/GetStationTypes',
    (url) => fetcher(url));

  return {
    stationTypes: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetStationTypes;
